import { regexEmail } from 'mailup-react-helpers'
import { FormElement, InputText, InputTextIcon } from 'mailup-web-components'
import { senderConfigState } from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

const InputSenderReplyTo = () => {
  const intl = useIntl()
  const [
    { SenderReplyTo, IsPecPlus, invalidReplyTo, replyToEmailIsDirty },
    setSenderConfig
  ] = useRecoilState(senderConfigState)

  const handleChangeReplyTo = (e) => {
    setSenderConfig((prev) => ({
      ...prev,
      IsDirty: true,
      SenderReplyTo: e.target.value,
      replyToEmailIsDirty: true,
      invalidReplyTo: !e.target.value.match(regexEmail)
    }))
  }

  return (
    <div>
      {IsPecPlus ? (
        <>
          <FormElement
            required
            label={intl.formatMessage({ id: 'Load.Common.ReplyToEmailLabel' })}
            labelHelp={intl.formatMessage({
              id: 'Load.PecPlus.replyToPecTooltip'
            })}
          >
            <InputTextIcon
              placeholder={SenderReplyTo}
              disabled
              data-mu-test='input-SenderReplyTo'
            />
          </FormElement>
        </>
      ) : (
        <>
          <FormElement
            required
            label={intl.formatMessage({ id: 'Load.Common.ReplyToEmailLabel' })}
            feedback={
              SenderReplyTo === ''
                ? intl.formatMessage({
                    id: 'Load.EmailSendingWizard.SenderNameRequired'
                  })
                : SenderReplyTo !== '' && invalidReplyTo && replyToEmailIsDirty
                  ? intl.formatMessage({ id: 'Load.Common.WrongFormatWarning' })
                  : undefined
            }
          >
            <InputText
              value={SenderReplyTo}
              onChange={handleChangeReplyTo}
              variant={
                (SenderReplyTo === '' || invalidReplyTo) && replyToEmailIsDirty
                  ? 'danger'
                  : null
              }
              data-mu-test='input-SenderReplyTo'
            />
          </FormElement>
        </>
      )}
    </div>
  )
}

export default InputSenderReplyTo
